import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { DutyFreeBuyingGuide } from "./DutyFreeBuyingGuide/DutyFreeBuyingGuide";
import { BaggageGuide } from "./BaggageGuide/BaggageGuide";
import { LagsAndRestrictedItems } from "./LagsAndRestrictedItems/LagsAndRestrictedItems";

export const TravellersInfo = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const subActiveTab = query.get('subActiveTab');
  const travellersInfoCard =[
    {
      label: "Baggage Guide",
      key: 'baggageGuide',
      children: <BaggageGuide/>
    },
    {
      label: "Lags & Restricted Items",
      key: "lagsAndRestrictedItems",
      children: <LagsAndRestrictedItems/>
    },
    {
      label: "Duty Free Buying Guide",
      key: 'dutyFreeBuyingGuide',
      children: <DutyFreeBuyingGuide/>
    }
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
